export const PROJECT_NAME = 'autopark'
